const roadmapSteps = [
  {
    number: '1',
    title: 'College/Student Partners with FutureLeadX',
    description: 'College or student partners with FutureLeadX and begins the journey.',
    image: '/images/journey/s1.png',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path
          d="M8 14c-2-2-2.5-4.5-1-6s4-1.5 6 .5l.5.5.5-.5c2-2 4.5-2.5 6-1s1 4-1 6l-5.5 5.5L8 14z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    number: '2',
    title: 'Industry Expert Designed Learning',
    description: 'Access industry expert-designed courses, live sessions and mentorship.',
    image: '/images/journey/s2.png',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M4 5h10a2 2 0 012 2v12l-5-2.5L6 19V7a2 2 0 012-2z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M16 7h2a2 2 0 012 2v10l-4-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    number: '3',
    title: 'Skill Development & Projects',
    description: 'Work on real-world projects, assessments and build in-demand skills.',
    image: '/images/journey/s3.png',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M8 8l-4 4 4 4M16 8l4 4-4 4M14 6l-4 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    number: '4',
    title: 'Live Internships',
    description: 'Gain hands-on experience through live internships with industry.',
    image: '/images/journey/s4.png',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
  },
  {
    number: '5',
    title: 'Top Performer Rewards & Placement Support',
    description: 'Top performers receive rewards and get placement support from our industry network.',
    image: '/images/journey/s5.png',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M12 3l2.2 4.4 4.8.7-3.5 3.4.8 4.8L12 14.5 7.7 16.3l.8-4.8L5 8.1l4.8-.7L12 3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    number: '6',
    title: 'Become an Industry Leader',
    description: 'Launch your career, create impact and become the industry leaders of tomorrow.',
    image: '/images/journey/s6.png',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.8" />
        <path d="M5 19c0-3.5 3.1-6 7-6s7 2.5 7 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M16 5.5l1 .5.5 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

function Journey() {
  return (
    <section id="journey" className="relative overflow-hidden bg-brand-white py-6 lg:py-10">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-brand-background/80 to-transparent" />

      <div className="relative mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="mx-auto mb-12 max-w-3xl text-center lg:mb-16">
          <p className="mb-3 text-label font-semibold uppercase tracking-[0.2em] text-brand-primary">
            Our Roadmap
          </p>
          <h2 className="text-section uppercase leading-tight tracking-wide text-brand-navy sm:text-[36px]">
            Your Journey Towards{' '}
            <span className="text-brand-primary">Professional Excellence</span>
          </h2>
          <div className="mx-auto mt-5 h-1 w-16 rounded-full bg-brand-primary" />
        </div>

        <div className="mb-6 overflow-hidden rounded-3xl border border-brand-border bg-brand-white px-4 py-10 shadow-[0_16px_50px_-30px_rgba(15,85,222,0.25)] sm:px-6 lg:px-8 lg:py-14">
          <p className="mb-10 text-center text-label font-semibold uppercase tracking-[0.18em] text-brand-primary">
            6 Steps To Career Success
          </p>

          <div className="relative">
            {/* Connecting path */}
            <div className="pointer-events-none absolute left-[8%] right-[8%] top-[88px] z-0 hidden h-3 lg:block">
              <svg viewBox="0 0 1000 24" preserveAspectRatio="none" className="h-full w-full" aria-hidden="true">
                <path
                  d="M0 12 C80 12, 100 4, 160 12 S260 20, 320 12 S420 4, 480 12 S580 20, 640 12 S740 4, 800 12 S900 20, 1000 12"
                  fill="none"
                  stroke="#0F55DE"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            <div className="-mx-2 flex snap-x snap-mandatory gap-4 overflow-x-auto px-2 pb-4 scrollbar-thin sm:gap-5 lg:mx-0 lg:grid lg:grid-cols-6 lg:gap-4 lg:overflow-visible lg:px-0 lg:pb-0 lg:snap-none">
              {roadmapSteps.map((step, index) => (
                <div
                  key={step.number}
                  className="relative z-10 flex w-[170px] shrink-0 snap-center flex-col items-center text-center sm:w-[200px] lg:w-auto"
                >
                  {/* Image bubble */}
                  <div className="relative mb-4 sm:mb-5">
                    <span className="absolute -left-1 -top-1 z-20 flex h-7 w-7 items-center justify-center rounded-full bg-brand-primary text-xs font-bold text-brand-white shadow-md shadow-brand-primary/40 sm:h-8 sm:w-8 sm:text-sm">
                      {step.number}
                    </span>
                    <div className="h-[120px] w-[120px] overflow-hidden rounded-full border-[3px] border-brand-primary bg-brand-white shadow-[0_12px_30px_-12px_rgba(15,85,222,0.45)] sm:h-[140px] sm:w-[140px] lg:h-[150px] lg:w-[150px]">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="h-full w-full object-cover"
                      />
                    </div>

                    {index < roadmapSteps.length - 1 ? (
                      <span className="absolute -right-4 top-1/2 z-20 hidden h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full bg-brand-primary text-brand-white shadow-md lg:flex xl:-right-5">
                        <svg viewBox="0 0 20 20" fill="currentColor" className="h-3.5 w-3.5" aria-hidden="true">
                          <path d="M7 4l7 6-7 6V4z" />
                        </svg>
                      </span>
                    ) : null}
                  </div>

                  <h3 className="mb-2 min-h-[44px] text-[13px] font-bold leading-snug text-brand-primary sm:min-h-[48px] sm:text-[15px]">
                    {step.title}
                  </h3>
                  <p className="mb-4 min-h-[52px] text-[11px] leading-relaxed text-brand-secondary sm:mb-5 sm:min-h-[60px] sm:text-label-sm">
                    {step.description}
                  </p>

                  <div className="mt-auto flex h-10 w-10 items-center justify-center rounded-full bg-brand-primary text-brand-white shadow-md shadow-brand-primary/30 sm:h-11 sm:w-11">
                    {step.icon}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Journey;
